import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../LandingPage.css'; // Assuming styles are still here or adjust path if needed

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Helper function for NavLink className
  const getNavLinkClass = ({ isActive }: { isActive: boolean }): string => {
    return `nav-link ${isActive ? 'active' : ''}`;
  };

  return (
    <header className="header" style={{
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      boxSizing: 'border-box'
    }}>
      <div className="header-content" style={{
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
        overflowY: 'hidden', // Explicitly hide vertical scrollbar
        overflowX: 'hidden'  // Explicitly hide horizontal scrollbar
      }}>
        <h1 className="logo">EFSoft</h1>
        <button
          className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`} onClick={isMenuOpen ? toggleMenu : undefined} style={{
          overflow: 'hidden' // Hide scrollbars in the nav menu
        }}>
          {/* Use NavLink and dynamic class with end prop for Home */}
          <NavLink to="/" className={getNavLinkClass} end>
            Home
          </NavLink>
          {/* Use NavLink and dynamic class for other items */}
          <NavLink to="/products" className={getNavLinkClass}>
            Our Products
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

export default Header;
